import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ProcessMonitoringProvider } from "./context/ProcessMonitoringContext";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import AdminRoute from "./components/auth/AdminRoute";
import ManagementRoute from "./components/auth/ManagementRoute";
import Layout from "./components/layout/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Leads from "./pages/Leads";
import Conversao from "./pages/Conversao";
import Conversoes from "./pages/Conversoes";
import Estruturacao from "./pages/Estruturacao";
import PublicacoesDje from "./pages/PublicacoesDje";
import Processos from "./pages/Processos";
import ProcessoDetalhes from "./pages/ProcessoDetalhes";
import Configuracoes from "./pages/Configuracoes";
import Monitoramento from "./pages/Monitoramento";
import Usuarios from "./pages/Usuarios";
import MeusMonitoramentos from "./pages/MeusMonitoramentos";
import AdvogadosParceiros from "./pages/AdvogadosParceiros";
import AgentConversations from "./pages/AgentConversations";
import AgentTraderAgenda from "./pages/AgentTraderAgenda";

import RoleRoute from "./components/auth/RoleRoute";
const ORIGINATION_ROLES = ["ADMIN", "BANKER", "TRADER", "TESTER"];
const MONITORING_ROLES = ["ADMIN", "ANALYST", "TESTER"];
const BUSINESS_ROLES = ["ADMIN", "BANKER", "TRADER", "ANALYST", "TESTER"];

export default function Router() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Rota pública de login */}
          <Route path="/login" element={<Login />} />

          {/* Rotas protegidas */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <ProcessMonitoringProvider>
                  <Layout>
                    <Routes>
                      <Route path="/" element={<Navigate to="/dashboard" replace />} />
                      <Route
                        path="/dashboard"
                        element={
                          <RoleRoute roles={ORIGINATION_ROLES}>
                            <Dashboard />
                          </RoleRoute>
                        }
                      />
                      <Route
                        path="/leads"
                        element={
                          <RoleRoute roles={ORIGINATION_ROLES}>
                            <Leads />
                          </RoleRoute>
                        }
                      />
                      <Route path="/conversao" element={<Navigate to="/conversoes" replace />} />
                      <Route
                        path="/conversoes"
                        element={
                          <RoleRoute roles={ORIGINATION_ROLES}>
                            <Conversoes />
                          </RoleRoute>
                        }
                      />
                      <Route
                        path="/carteira"
                        element={
                          <ManagementRoute>
                            <Estruturacao />
                          </ManagementRoute>
                        }
                      />
                      <Route path="/publicacoes" element={<Navigate to="/publicacoes-dje" replace />} />
                      <Route
                        path="/publicacoes-dje"
                        element={
                          <RoleRoute roles={MONITORING_ROLES}>
                            <PublicacoesDje />
                          </RoleRoute>
                        }
                      />
                      <Route
                        path="/processos"
                        element={
                          <RoleRoute roles={MONITORING_ROLES}>
                            <Processos />
                          </RoleRoute>
                        }
                      />
                      <Route
                        path="/advogados-parceiros"
                        element={
                          <RoleRoute roles={ORIGINATION_ROLES}>
                            <AdvogadosParceiros />
                          </RoleRoute>
                        }
                      />
                      <Route
                        path="/processo/:id"
                        element={
                          <RoleRoute roles={BUSINESS_ROLES}>
                            <ProcessoDetalhes />
                          </RoleRoute>
                        }
                      />
                      <Route
                        path="/monitoramento"
                        element={
                          <RoleRoute roles={MONITORING_ROLES}>
                            <Monitoramento />
                          </RoleRoute>
                        }
                      />
                      <Route path="/meus-monitoramentos" element={<MeusMonitoramentos />} />
                      <Route
                        path="/configuracoes"
                        element={
                          <AdminRoute>
                            <Configuracoes />
                          </AdminRoute>
                        }
                      />
                      <Route
                        path="/usuarios"
                        element={
                          <AdminRoute>
                            <Usuarios />
                          </AdminRoute>
                        }
                      />
                      <Route path="/atendimento/canais" element={<Navigate to="/configuracoes?tab=canais" replace />} />
                      <Route
                        path="/atendimento/conversas"
                        element={
                          <RoleRoute roles={ORIGINATION_ROLES}>
                            <AgentConversations />
                          </RoleRoute>
                        }
                      />
                      <Route
                        path="/atendimento/agenda"
                        element={
                          <RoleRoute roles={ORIGINATION_ROLES}>
                            <AgentTraderAgenda />
                          </RoleRoute>
                        }
                      />
                      <Route path="/atendimento/playbook" element={<Navigate to="/configuracoes?tab=playbook" replace />} />
                    </Routes>
                  </Layout>
                </ProcessMonitoringProvider>
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
